export const financialConstants = {
  GET_FINANCIALURL_SUCCESS: "GET_FINANCIALURL_SUCCESS",
  GET_FINANCIALURL_FAILURE: "GET_FINANCIALURL_FAILURE",
  POST_FINANCIALLOGINIFRAMEURL_SUCCESS: "POST_FINANCIALLOGINIFRAMEURL_SUCCESS",
  POST_FINANCIALLOGINIFRAMEURL_FAILURE: "POST_FINANCIALLOGINIFRAMEURL_FAILURE",
}